import { useState, useRef, useEffect } from 'react';

/**
 * Hook that waits for window.caiEventBus to be ready and returns the instance.
 * Polls every 100ms up to 2 seconds, same pattern as ws-track-my-offer.
 * @returns {[Object|null, boolean]} [eventBus, isReady]
 */
const useEventBus = () => {
	const eventBusRef = useRef(null);
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		let intervalId;
		let timeoutId;

		if (window.caiEventBus) {
			eventBusRef.current = window.caiEventBus;
			setIsReady(true);
		} else {
			timeoutId = setTimeout(() => {
				clearInterval(intervalId);
			}, 2000);

			const checkForEventBus = () => {
				if (window.caiEventBus) {
					eventBusRef.current = window.caiEventBus;
					setIsReady(true);
					clearInterval(intervalId);
					clearTimeout(timeoutId);
				}
			};
			intervalId = setInterval(checkForEventBus, 100);
		}

		return () => {
			clearInterval(intervalId);
			clearTimeout(timeoutId);
		};
	}, []);

	return [eventBusRef.current, isReady];
};

export default useEventBus;
